import { MenuToggleContext } from '@/base/layouts/contexts/MenuToggleContext';
import { useUserStore } from '@/user/stores/userStore';
import { Avatar, Box } from '@mui/material';
import { useContext } from 'react';
import { UserBoxLabel, UserBoxText } from '../../UserMenu/UserMenu.styles';
import { UserBoxButton } from './UserboxMenuButton.styles';
import useAccountStore from '@/user/stores/accountStore';
import { UserboxDaysLeftWarning } from '../../../UserboxDaysLeftWarning/UserboxDaysLeftWarning';

export const UserboxMenuButton = () => {
  const {
    profile: { email, name, picture }
  } = useUserStore();
  const {
    daysTrialEndNumber,
    status,
    plan: { name: planName }
  } = useAccountStore();

  const { goToUserBox } = useContext(MenuToggleContext);

  const renderUserSummary = () => {
    return (
      <UserBoxText>
        <UserBoxLabel variant="body1">{name || email}</UserBoxLabel>
        {status === 'ACTIVE' && <>{planName}</>}
        {status === 'TRIALING' && (
          <UserboxDaysLeftWarning
            daysLeft={daysTrialEndNumber}
            planName="Trial"
          />
        )}
      </UserBoxText>
    );
  };

  return (
    <UserBoxButton color="primary" onClick={goToUserBox}>
      <Avatar variant="circular" alt={name} src={picture} />
      <Box>{renderUserSummary()}</Box>
    </UserBoxButton>
  );
};
